export default __webpack_public_path__ + "static/media/247.d1de4317.png";